module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_4.7202c077.png";